export const YOUTUBE_COM = 'youtube.com'
export const YOUTUBE_BE = 'youtu.be'

const isYoutube = (link: string) => {
  try {
    const url = new URL(link)

    return (
      url.hostname === YOUTUBE_COM ||
      url.hostname === YOUTUBE_BE ||
      url.hostname === `www.${YOUTUBE_COM}` ||
      url.hostname === `www.${YOUTUBE_BE}`
    )
  } catch (error) {
    return false
  }
}

export default isYoutube
